// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/historian.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_symbol } from "./symbol_pb.js";
/**
 * Describes the file vitesse/v1/historian.proto.
 */
export const file_vitesse_v1_historian = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common, file_vitesse_v1_symbol]);
/**
 * Describes the message vitesse.v1.HistorianDescriptor.
 * Use `create(HistorianDescriptorSchema)` to create a new message.
 */
export const HistorianDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 0);
/**
 * Describes the message vitesse.v1.QueryRangeRequest.
 * Use `create(QueryRangeRequestSchema)` to create a new message.
 */
export const QueryRangeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 1);
/**
 * Describes the message vitesse.v1.SampleRow.
 * Use `create(SampleRowSchema)` to create a new message.
 */
export const SampleRowSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 2);
/**
 * Describes the message vitesse.v1.QueryRangeReply.
 * Use `create(QueryRangeReplySchema)` to create a new message.
 */
export const QueryRangeReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 3);
/**
 * Describes the message vitesse.v1.QueryAggregatedRequest.
 * Use `create(QueryAggregatedRequestSchema)` to create a new message.
 */
export const QueryAggregatedRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 4);
/**
 * Describes the message vitesse.v1.AggBucket.
 * Use `create(AggBucketSchema)` to create a new message.
 */
export const AggBucketSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 5);
/**
 * Describes the message vitesse.v1.AggEnvelope.
 * Use `create(AggEnvelopeSchema)` to create a new message.
 */
export const AggEnvelopeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 6);
/**
 * Describes the message vitesse.v1.QueryAggregatedReply.
 * Use `create(QueryAggregatedReplySchema)` to create a new message.
 */
export const QueryAggregatedReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 7);
/**
 * Describes the message vitesse.v1.ExportParquetRequest.
 * Use `create(ExportParquetRequestSchema)` to create a new message.
 */
export const ExportParquetRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 8);
/**
 * Describes the message vitesse.v1.ExportParquetReply.
 * Use `create(ExportParquetReplySchema)` to create a new message.
 */
export const ExportParquetReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 9);
/**
 * Describes the message vitesse.v1.QueryBoundsRequest.
 * Use `create(QueryBoundsRequestSchema)` to create a new message.
 */
export const QueryBoundsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 10);
/**
 * Describes the message vitesse.v1.QueryBoundsReply.
 * Use `create(QueryBoundsReplySchema)` to create a new message.
 */
export const QueryBoundsReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 11);
/**
 * Describes the message vitesse.v1.DrExportRequest.
 * Use `create(DrExportRequestSchema)` to create a new message.
 */
export const DrExportRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 12);
/**
 * Describes the message vitesse.v1.DrExportReply.
 * Use `create(DrExportReplySchema)` to create a new message.
 */
export const DrExportReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 13);
/**
 * Describes the message vitesse.v1.DrIngestRequest.
 * Use `create(DrIngestRequestSchema)` to create a new message.
 */
export const DrIngestRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 14);
/**
 * Describes the message vitesse.v1.DrIngestReply.
 * Use `create(DrIngestReplySchema)` to create a new message.
 */
export const DrIngestReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 15);
/**
 * Describes the message vitesse.v1.DrStatusRequest.
 * Use `create(DrStatusRequestSchema)` to create a new message.
 */
export const DrStatusRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 16);
/**
 * Describes the message vitesse.v1.DrStatusReply.
 * Use `create(DrStatusReplySchema)` to create a new message.
 */
export const DrStatusReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_historian, 17);
/**
 * ─── queryAggregated ────────────────────────────────────────────────────
 * Subject: cmd.<gw>.historian.queryAggregated
 *
 * Returns time-bucketed scalar aggregates for ONE symbol. Charts use
 * this at any zoom level — server computes via ClickHouse's
 * `toStartOfInterval` + GROUP BY. Per-bucket cost is constant whether
 * the bucket holds 10 or 10,000 source rows; bandwidth scales with
 * bucket count, not source-row count.
 *
 * @generated from enum vitesse.v1.AggKind
 */
export var AggKind;
(function (AggKind) {
    /**
     * @generated from enum value: AGG_KIND_UNSPECIFIED = 0;
     */
    AggKind[AggKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: AGG_KIND_MIN = 1;
     */
    AggKind[AggKind["MIN"] = 1] = "MIN";
    /**
     * @generated from enum value: AGG_KIND_MAX = 2;
     */
    AggKind[AggKind["MAX"] = 2] = "MAX";
    /**
     * @generated from enum value: AGG_KIND_AVG = 3;
     */
    AggKind[AggKind["AVG"] = 3] = "AVG";
    /**
     * @generated from enum value: AGG_KIND_SUM = 4;
     */
    AggKind[AggKind["SUM"] = 4] = "SUM";
    /**
     * @generated from enum value: AGG_KIND_COUNT = 5;
     */
    AggKind[AggKind["COUNT"] = 5] = "COUNT";
    /**
     * min, max AND avg for every bucket in one reply: each AggBucket carries
     * `envelope`, and `value` is the avg. The chart's band-plus-line needs all
     * three, and asking for them as three single-kind RPCs paid every
     * per-request cost (gateway JWT verify, NATS round trip, marshal, cache
     * entry) three times for what is one scan on the historian.
     *
     * @generated from enum value: AGG_KIND_ENVELOPE = 6;
     */
    AggKind[AggKind["ENVELOPE"] = 6] = "ENVELOPE";
})(AggKind || (AggKind = {}));
/**
 * Describes the enum vitesse.v1.AggKind.
 */
export const AggKindSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_historian, 0);
/**
 * Browser-facing service. Bridged by api-gateway:
 *
 *   Browser → api-gateway : Historian.QueryRange / QueryAggregated / ExportParquet (Connect-unary)
 *   api-gateway → NATS    : nc.Request("org.<org>.cmd.<gw>.historian.<verb>", req)
 *   historian → NATS      : reply with the Reply message
 *
 * On edge the api-gateway dispatches to the LOCAL historian; on cloud the
 * browser may instead hit a separate Historian Worker (Cloudflare) for
 * longer-than-edge-retention ranges. Routing decision is the UI's per
 * rule 52; both paths take the same proto.
 *
 * @generated from service vitesse.v1.Historian
 */
export const Historian = /*@__PURE__*/ serviceDesc(file_vitesse_v1_historian, 0);
//# sourceMappingURL=historian_pb.js.map